<!-- 外部价格趋势图 -->
<template>
  <div class="priceEchart">
    <el-dialog
      title="价格趋势图"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <!-- 查重结果 -->
      <div id="chart" ref="chart" style="width: 100%; min-height: 300px"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleClose">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import echarts from '@/plugins/echarts.js';
  export default {
    name: 'priceEchart',
    props: ['tableData'],
    data() {
      return {
        dialogVisible: false,
      };
    },
    methods: {
      openDialog() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getEchartData();
        });
      },
      getEchartData() {
        let priceList = [];
        let timeList = [];
        const tableData = JSON.parse(JSON.stringify(this.tableData));
        tableData.reverse().forEach((item) => {
          priceList.push(item.priceValue);
          timeList.push(item.priceCreateTime);
        });
        var myChart = echarts.init(this.$refs.chart);
        var option = {
          xAxis: {
            type: 'category',
            data: timeList,
          },
          yAxis: {
            type: 'value',
            // name:tableData[0].tradeCurrencyName||''
          },
          series: [
            {
              data: priceList,
              type: 'line',
            },
          ],
        };
        myChart.setOption(option);
      },
      handleClose() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style scoped></style>
